module.exports = __webpack_public_path__ + "static/media/pic4.a5c45dad.jpg";